import { TicketTypes } from '@tickets/constants';

export const getTicketIndex = (ticket, list) => {
  const { ticketType, dataFromSwarm } = ticket;

  if (ticketType === TicketTypes.DEPOSIT) {
    return list[ticketType].findIndex(
      (item) => item.dataFromSwarm.barcode.toString() === dataFromSwarm.barcode?.toString()
    );
  }
  if (ticketType === TicketTypes.SPORT) {
    return list[ticketType].findIndex(
      (item) => item?.dataFromSwarm?.barcode?.toString() === dataFromSwarm.barcode?.toString()
    );
  }
  if (ticketType === TicketTypes.CASINO) {
    return list[ticketType].findIndex((item) => item?.dataFromSwarm?.ExternalId === ticket.dataFromSwarm.ExternalId);
  }
};
